import React from "react";

export default function PageHeader({ title, description, action }) {
  return (
    <div className="flex items-center justify-between gap-4 rounded-lg border border-gray-200 bg-white px-4 py-3">
      <div>
        <h1 className="text-xl font-bold text-gray-900 leading-tight">
          {title}
        </h1>
        {description && (
          <p className="mt-0.5 text-[13px] text-gray-500">{description}</p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
